const numberWithCommas = (x: number) => {
  if (!x) {
    return '0';
  }

  return Math.round(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default numberWithCommas;
